import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HelpIcon from "@mui/icons-material/Help";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Backdrop,
    Box,
    Button,
    CircularProgress,
    DialogContent,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    IconButton,
    Radio,
    RadioGroup,
    Checkbox,
    Tab,
    Tabs,
    TextField,
    TextareaAutosize,
    Tooltip,
    Typography,
} from "@mui/material";
import DndComponent from "common/components/DndComponent/DndComponent";
import GenericAlert from "common/components/GenericAlert/GenericAlert";
import GenericDialog from "common/components/GenericDialog/GenericDialog";
import GenericTable from "common/components/GenericTable/GenericTable";
import TabPanelComponent from "common/components/TabPanel/TabPanelComponent";
import { ApiService } from "common/services/ApiService";
import { toSnakeCase } from "helpers/TextHelpers";
import BubbleChart from "modules/activity/pages/Activities/components/BubbleChart";
import ColumnsChart from "modules/activity/pages/Activities/components/ColumnsChart";
import FilterDataset from "modules/activity/pages/Activities/components/FiltersDataset";
import LineChart from "modules/activity/pages/Activities/components/LineChart";
import MapChartGrapher from "modules/activity/pages/Activities/components/MapChartGrapher";
import PieChart from "modules/activity/pages/Activities/components/PieChart";
import QuestionAnswerForum from "modules/activity/pages/Activities/components/QuestionAnswerForum";
import StaticNetworkBetweennessChart from "modules/activity/pages/Activities/components/StaticNetworkBetweennessChart";
import StaticNetworkChart from "modules/activity/pages/Activities/components/StaticNetworkChart";
import useStyles from "modules/activity/pages/Activities/components/styles";
import WordCloudChart from "modules/activity/pages/Activities/components/WordCloudChart";
import WordCloudAppearanceControls from "./WordCloudAppearanceControls";
import SocialGraphs from "modules/activity/pages/SocialGraphs/SocialGraphs";
import { useEffect, useState } from "react";
import { DEFAULT_DATA_GRAPHER, STOPWORD_GROUPS, getWordCloudStopwordGroups } from "utils/constants";
import { exportGraphToImg, exportMultipleChartsToPdf } from "utils/exportPdf";
import GrapherResolutionData from "./GrapherResolutionData";
import { useParams } from "react-router-dom";

const TabNewResolution = ({
    datasetColumns,
    graphSelectedMap,
    setGraphSelectedMap,
    includeChipList,
    excludeChipList,
    setIncludeChipList,
    setExcludeChipList,
    studentActivityId,
    graphListAvailable,
    graphs,
    actualGraph,
    setActualGraph,
    handleChangeTabDataSource,
    studentActivity,
    getStudentActivity,
    callbackHandleChangeTabPanel,
    handleOpenTutorial,
    dataSource,
    mapGraphSelectedMapTab,
    onDeleteFilterApplied,
    valueTabParent,
    activity,
}) => {
    const { idActivity } = useParams();
    const staticdataSource = activity?.static_data_source;
    const [openDialogFilter, setOpenDialogFilter] = useState(false);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const hasSelectedGraphs = Object.values(graphSelectedMap).some((graph) => graph.selected);
    const [openPartialDeliveryDialog, setOpenPartialDeliveryDialog] = useState(false);
    const [openResolutionDialog, setOpenResolutionDialog] = useState(false);
    const [valueTab, setValueTab] = useState(0);
    const [valueGraphTab, setValueGraphTab] = useState(0);

    const [openLoader, setOpenLoader] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [severity, setSeverity] = useState("");
    const [alertText, setAlertText] = useState("");

    const [commentResolution, setCommentResolution] = useState("");
    const [commentEditActualGraph, setCommentEditActualGraph] = useState("");
    const [openDialogActualComment, setOpenDialogActualComment] = useState(false);
    const [openAddToDelivery, setOpenAddToDelivery] = useState(false);
    const [openAnotherSearch, setOpenAnotherSearch] = useState(false);
    const [openRemoveGraph, setOpenRemoveGraph] = useState(false);
    const [confirmEditComment, setConfirmEditComment] = useState(false);
    const [refreshResetDnd, setRefreshResetDnd] = useState(false);

    const criterionMapList = {
        include: [includeChipList, setIncludeChipList],
        exclude: [excludeChipList, setExcludeChipList],
    };
    const dataSourceMap = {
        0: "static",
        1: "dynamic",
    };

    const classes = useStyles();

    const API_GRAPHER = {
        dataTable: ApiService.getDataGraphBasic,
        column: ApiService.getDataGraphColumn,
        line: ApiService.getDataGraphColumn,
        pie: ApiService.getDataGraphBasic,
        bubble: ApiService.getDataGraphColumn,
        dispersion: ApiService.getDataGraphColumn,
        map: ApiService.getDataGraphMap,
        social_word_frequency: ApiService.getRedditGraph,
        social_user_comments: ApiService.getRedditGraphUserComments,
        static_network: ApiService.getDataGraph,
        word_cloud: ApiService.getDataWordCloud,
    };

    const [dataGraph, setDataGraph] = useState({
        dataTable: {},
        column: {},
        line: {},
        pie: {},
        bubble: {},
        dispersion: {},
        map: {},
        social: {},
        social_word_frequency: {},
        social_user_comments: {},
        static_network: {},
        word_cloud: {},
    });

    const mapValueGraphTab = {
        0: "normal",
        1: "betweenness",
    };

    const handleChangeGraph = (event) => {
        setIncludeChipList([]);
        setExcludeChipList([]);
        setActualGraph(event.target.value);
        setRefreshResetDnd(!refreshResetDnd);
    };

    const checkSelectedColumns = () => {
        if (staticdataSource === null) {
            return true;
        }
        const columns = graphSelectedMap[actualGraph].columns;
        return Object.entries(columns)
            .filter(([k, v]) => k !== "datasetColumns")
            .every(([k, v]) => v.length > 0);
    };

    const saveFilter = () => {
        setGraphSelectedMap({
            ...graphSelectedMap,
            [actualGraph]: {
                ...graphSelectedMap[actualGraph],
                filterInclude: includeChipList,
                filterExclude: excludeChipList,
            },
        });
        setOpenDialogFilter(!openDialogFilter);
    };

    const addFilterCallback = (newCriterion, criterionsNew, criterionType) => {
        const [criterions, setCriterions] = criterionMapList[criterionType];
        setCriterions([...criterionsNew, newCriterion]);
    };

    const onDeleteFilterCallback = (obj, criterion) => {
        const [criterions, setCriterions] = criterionMapList[criterion];
        const criterionsFiltered = criterions.filter((crit) => crit.valueChip !== obj.valueChip);
        setCriterions(criterionsFiltered);
    };

    const updateColumns = (dataUpdated) => {
        const dataUpdatedAux = { ...dataUpdated };

        setGraphSelectedMap({
            ...graphSelectedMap,
            [actualGraph]: {
                ...graphSelectedMap[actualGraph],
                columns: dataUpdatedAux,
            },
        });
    };

    const handleClickGraphicWithoutDnd = async () => {
        setOpenLoader(true);

        try {
            let api = API_GRAPHER[actualGraph];
            const wordCloudConfiguration = graphSelectedMap.word_cloud || {};
            const result = await api(
                {
                    word_limit: wordCloudConfiguration.wordLimit ?? 100,
                    stopword_groups: getWordCloudStopwordGroups(wordCloudConfiguration),
                    custom_stopwords: wordCloudConfiguration.customStopwords || [],
                },
                activity.id
            );

            setDataGraph({
                ...dataGraph,
                [actualGraph]: result.data,
            });
        } catch (error) {
            setAlertText("Ocurrió un error intente nuevamente!");
            setSeverity("error");
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
                setAlertText("");
                setSeverity("");
            }, 3000);
        } finally {
            setOpenLoader(false);
        }
    };

    const updateWordCloudConfiguration = (configuration) => {
        setGraphSelectedMap({
            ...graphSelectedMap,
            word_cloud: {
                ...DEFAULT_DATA_GRAPHER.word_cloud,
                ...graphSelectedMap.word_cloud,
                stopwordGroups: getWordCloudStopwordGroups(graphSelectedMap.word_cloud),
                ...configuration,
            },
        });
    };

    const handleClickGraphic = async () => {
        setOpenLoader(true);

        try {
            const projectHeadersMap = {};
            if (graphSelectedMap[actualGraph].columns.value?.length > 0) {
                graphSelectedMap[actualGraph].columns.value?.forEach((h) => {
                    projectHeadersMap[h] = 1;
                });
            }

            const includeHeadersMap = {};
            const excludeHeadersMap = {};

            graphSelectedMap[actualGraph].filterInclude.forEach((obj) => {
                if (!(obj.column in includeHeadersMap)) {
                    includeHeadersMap[obj.column] = [];
                }
                includeHeadersMap[obj.column].push(obj.valueFilter);
            });
            graphSelectedMap[actualGraph].filterExclude.forEach((obj) => {
                if (!(obj.column in excludeHeadersMap)) {
                    excludeHeadersMap[obj.column] = [];
                }
                excludeHeadersMap[obj.column].push(obj.valueFilter);
            });

            let api = API_GRAPHER[actualGraph];

            if (actualGraph === "static_network" && valueGraphTab === 1) {
                api = ApiService.getDataGraphBetweenness;
            }

            const result = await api(
                {
                    graph: actualGraph,
                    project_headers_map: projectHeadersMap,
                    columns: graphSelectedMap[actualGraph].columns,
                    include_headers_map: includeHeadersMap,
                    exclude_headers_map: excludeHeadersMap,
                },
                activity.id
            );

            setDataGraph((prev) => ({
                ...prev,
                [actualGraph]: result.data,
            }));

            setTimeout(() => {
                const chartElement = document.getElementById("chart-component");
                if (chartElement) {
                    chartElement.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 300);
        } catch (error) {
            setAlertText("Ocurrió un error intente nuevamente!");
            setSeverity("error");
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
                setAlertText("");
                setSeverity("");
            }, 3000);
        } finally {
            setOpenLoader(false);
        }
    };

    const sendResolution = async () => {
        setOpenLoader(true);
        setOpenConfirmDialog(false);
        try {
            const partialDeliveryJson = {};
            const graphs = [];

            Object.entries(graphSelectedMap).forEach(([k, el]) => {
                const keySnaked = toSnakeCase(k);
                if (el.selected) {
                    graphs.push(keySnaked);
                    partialDeliveryJson[keySnaked] = el;
                }
            });

            if (graphs.length === 0) {
                setOpenLoader(false);
                setAlertText("Agregá al menos un gráfico a la entrega antes de enviarla.");
                setSeverity("error");
                setShowAlert(true);
                return;
            }

            const data = {
                partial_delivery_json: partialDeliveryJson,
                student_activity: studentActivityId,
                comment: commentResolution,
                graphs,
            };

            const res = await ApiService.createStudentActivityResolution(data);
            setOpenLoader(false);
            if (res.status === 200) {
                setAlertText("La actividad se entregó con éxito!");
                setSeverity("success");
                setShowAlert(true);
                setTimeout(() => {
                    setShowAlert(false);
                    setAlertText("");
                    setSeverity("");
                    callbackHandleChangeTabPanel();
                    //aca habria q cambiar de TAB
                }, 1500);
            } else {
                setAlertText("Ocurrió un error, intente nuevamente!");
                setSeverity("error");
                setShowAlert(true);
                setTimeout(() => {
                    setShowAlert(false);
                    setAlertText("");
                    setSeverity("");
                }, 1500);
            }
        } catch (error) {
            setAlertText("Ocurrió un error, intente nuevamente!");
            setSeverity("error");
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
                setAlertText("");
                setSeverity("");
            }, 1500);
        }
    };

    const tooltipHowToGraphic = (disabled) => {
        const title =
            valueTab === 0
                ? "Las fuentes estáticas son conjuntos de datos previamente recopilados, almacenados y que no cambian con el paso del tiempo. En esta versión de Alfadatizando se accede a ellos a través de archivos con extensión .csv o .pdf."
                : "Las fuentes dinámicas son datos que se obtienen y procesan en tiempo real, a partir de flujos activos de información como los que generan plataformas digitales. En esta versión de Alfadatizando se accede a ellos a través de Reddit.";
        return (
            <Tooltip
                enterTouchDelay={0}
                leaveTouchDelay={15000}
                disableTouchListener={false}
                title={title}
            >
                <HelpIcon></HelpIcon>
                {/* Esto de abajo sería si lo usamos para abrir el tutorial con un modal */}
                {/* <IconButton
                    disabled={disabled}
                    onClick={() => handleOpenTutorial(valueTab === 0 ? "static" : "dynamic")}
                >
                    <HelpIcon></HelpIcon>
                </IconButton> */}
            </Tooltip>
        );
    };

    const handleChangeTab = (event, newValue) => {
        setValueTab(newValue);
        handleChangeTabDataSource(dataSourceMap[newValue]);
    };

    const handleChangeGraphTab = (event, newValue) => {
        setGraphSelectedMap({
            ...graphSelectedMap,
            [actualGraph]: {
                ...graphSelectedMap[actualGraph],
                metric: mapValueGraphTab[valueGraphTab],
            },
        });
        setDataGraph({
            ...dataGraph,
            [actualGraph]: {},
        });
        setValueGraphTab(newValue);
        // handleChangeTabDataSource(dataSourceMap[newValue]);
    };

    const onClickAddPartialDelivery = () => {
        if (graphSelectedMap[actualGraph].selected) {
            setOpenRemoveGraph(true);
            return;
        }
        setOpenPartialDeliveryDialog(true);
    };

    const addPartialDelivery = async () => {
        try {
            setOpenPartialDeliveryDialog(false);
            const exportData = {};

            if (!graphSelectedMap[actualGraph].selected) {
                const el = document.getElementById("chart-component");
                exportData.offsetHeight = el.offsetHeight;
                exportData.offsetWidth = el.offsetWidth;
                exportData.image = await exportGraphToImg(el);
            }

            setGraphSelectedMap({
                ...graphSelectedMap,
                [actualGraph]: {
                    ...graphSelectedMap[actualGraph],
                    selected: !graphSelectedMap[actualGraph].selected,
                    export: exportData,
                },
            });

            setOpenLoader(false);
        } catch (error) {
            console.error("Error exportando", error);
            setOpenLoader(false);
        }
    };

    useEffect(() => {
        if (staticdataSource !== undefined && staticdataSource !== null) {
            setValueTab(0);
            setValueGraphTab(0);
        } else {
            setValueTab(1);
            setValueGraphTab(1);
        }
    }, [staticdataSource]);

    return (
        <div>
            <Grid container pb={5} gap={1}>
                <Grid container>
                    <Grid item xs={12} md={6}>
                        <Tabs
                            value={valueTab}
                            onChange={handleChangeTab}
                            aria-label="basic tabs example"
                        >
                            <Tab
                                disabled={staticdataSource === null}
                                label={
                                    <Box display="flex" alignItems="center" gap={1}>
                                        Fuentes Estáticas
                                        {tooltipHowToGraphic(staticdataSource === null)}
                                    </Box>
                                }
                            />
                            <Tab
                                disabled={staticdataSource !== null}
                                label={
                                    <Box display="flex" alignItems="center" gap={1}>
                                        Fuentes Dinámicas
                                        {tooltipHowToGraphic(staticdataSource !== null)}
                                    </Box>
                                }
                            />
                        </Tabs>
                    </Grid>
                </Grid>
            </Grid>
            <TabPanelComponent value={valueTab} index={0}>
                {actualGraph === "word_cloud" && (
                    <Grid container>
                        <Grid item xs={12}>
                            <div>
                                <h3>Seleccionar tipo de gráfico</h3>
                            </div>
                            <div>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                        name="controlled-radio-buttons-group"
                                        value={actualGraph}
                                        onChange={handleChangeGraph}
                                    >
                                        {graphListAvailable.length > 0 &&
                                            graphs
                                                .filter(
                                                    (graph) =>
                                                        graph.dataSource === "static" &&
                                                        graphListAvailable.includes(graph.value)
                                                )
                                                .sort((a, b) => a.name.localeCompare(b.name))
                                                .map((graph) => (
                                                    <div>
                                                        <FormControlLabel
                                                            key={graph.value}
                                                            value={graph.value}
                                                            control={<Radio />}
                                                            label={
                                                                <Tooltip
                                                                    enterTouchDelay={0}
                                                                    leaveTouchDelay={15000}
                                                                    disableTouchListener={false}
                                                                    title={
                                                                        <img
                                                                            src={`/img/charts/${graph.name}.png`}
                                                                            alt={graph.name}
                                                                            width="100%"
                                                                            // height="20"
                                                                        />
                                                                    }
                                                                >
                                                                    <p>{graph.name}</p>
                                                                </Tooltip>
                                                            }
                                                        />
                                                        <Tooltip
                                                            enterTouchDelay={0}
                                                            leaveTouchDelay={15000}
                                                            disableTouchListener={false}
                                                            title={
                                                                <p
                                                                    style={{
                                                                        margin: 0,
                                                                        paddingLeft: 0,
                                                                        fontSize: 12,
                                                                    }}
                                                                >
                                                                    La nube incluye la cantidad de
                                                                    palabras configurada, ordenadas
                                                                    por cantidad de apariciones.
                                                                    <br />
                                                                    Las cantidades totales para cada
                                                                    palabra en el texto completo se
                                                                    visualiza en la lista “Cantidad
                                                                    de veces que aparece cada
                                                                    palabra en el texto completo”.
                                                                </p>
                                                            }
                                                        >
                                                            <IconButton size="small">
                                                                <HelpIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </div>
                                                ))}
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <Grid item xs={12} md={8} sx={{ mb: 2 }}>
                                <h3>Configuración de la nube</h3>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            fullWidth
                                            label="Cantidad máxima de palabras"
                                            type="number"
                                            inputProps={{ min: 1, max: 500 }}
                                            disabled={Object.keys(dataGraph[actualGraph] || {}).length > 0}
                                            value={graphSelectedMap.word_cloud?.wordLimit ?? 100}
                                            onChange={(event) => {
                                                const value = Number(event.target.value);
                                                updateWordCloudConfiguration({
                                                    wordLimit: Math.min(500, Math.max(1, value || 1)),
                                                });
                                            }}
                                            helperText="Entre 1 y 500"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl component="fieldset" fullWidth>
                                            <Typography component="legend">
                                                <Box component="span" display="inline-flex" alignItems="center" gap={0.5}>
                                                    Stopwords a excluir
                                                    <Tooltip
                                                        enterTouchDelay={0}
                                                        leaveTouchDelay={15000}
                                                        title="Las stopwords son palabras frecuentes, como «el», «de» o «y», que suelen aportar poco al tema del texto. Excluirlas ayuda a destacar las palabras más relevantes. Podés elegir qué grupos excluir."
                                                    >
                                                        <IconButton size="small" aria-label="¿Qué son las stopwords?">
                                                            <HelpIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                            </Typography>
                                            <Grid container>
                                                {STOPWORD_GROUPS.map((group) => (
                                                    <Grid item xs={12} sm={6} md={4} key={group.value}>
                                                        <Box display="flex" alignItems="center">
                                                        <FormControlLabel
                                                            sx={{ mr: 0 }}
                                                            control={
                                                                <Checkbox
                                                                    checked={getWordCloudStopwordGroups(graphSelectedMap.word_cloud).includes(group.value)}
                                                                    disabled={Object.keys(dataGraph[actualGraph] || {}).length > 0}
                                                                    onChange={(event) => {
                                                                        const selected = getWordCloudStopwordGroups(graphSelectedMap.word_cloud);
                                                                        updateWordCloudConfiguration({
                                                                            stopwordGroups: event.target.checked
                                                                                ? [...selected, group.value]
                                                                                : selected.filter((value) => value !== group.value),
                                                                        });
                                                                    }}
                                                                />
                                                            }
                                                            label={group.label}
                                                        />
                                                        <Tooltip
                                                            enterTouchDelay={0}
                                                            leaveTouchDelay={15000}
                                                            title={`${group.label}: ${group.words}${group.examplesOnly ? ", etc." : "."}`}
                                                        >
                                                            <IconButton size="small" aria-label={`Ver stopwords: ${group.label}`}>
                                                                <HelpIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                        </Box>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                            <FormHelperText>
                                                Marcá los grupos de stopwords que querés excluir del texto.
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            multiline
                                            minRows={2}
                                            label="Palabras adicionales a excluir"
                                            placeholder="Ej.: alumno, actividad, consigna"
                                            disabled={Object.keys(dataGraph[actualGraph] || {}).length > 0}
                                            value={
                                                (graphSelectedMap.word_cloud?.customStopwords || []).join(", ")
                                            }
                                            onChange={(event) =>
                                                updateWordCloudConfiguration({
                                                    customStopwords: event.target.value
                                                        .split(/[,;]/)
                                                        .map((word) => word.trim())
                                                        .filter(Boolean),
                                                })
                                            }
                                            helperText="Separe las palabras con comas o punto y coma."
                                        />
                                    </Grid>
                                    <WordCloudAppearanceControls
                                        configuration={graphSelectedMap.word_cloud}
                                        onChange={updateWordCloudConfiguration}
                                        disabled={Boolean(graphSelectedMap.word_cloud?.selected)}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                display={"flex"}
                                justifyContent={"center"}
                                gap={5}
                                mb={2}
                            >
                                <Button
                                    disabled={Object.keys(dataGraph[actualGraph] || {}).length > 0}
                                    variant="contained"
                                    onClick={() => handleClickGraphicWithoutDnd()}
                                >
                                    Graficar
                                </Button>
                                <Button
                                    variant="contained"
                                    disabled={
                                        Object.keys(dataGraph[actualGraph] || {}).length === 0
                                    }
                                    onClick={() => {
                                        setOpenAnotherSearch(!openAnotherSearch);
                                    }}
                                >
                                    Reiniciar gráfico
                                </Button>
                            </Grid>
                            <Accordion defaultExpanded>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography>Gráfico</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <WordCloudChart
                                        data={dataGraph[actualGraph]?.words_graph || {}}
                                        configuration={graphSelectedMap.word_cloud}
                                    />
                                </AccordionDetails>
                            </Accordion>

                            <Accordion defaultExpanded>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography>
                                        Listado de palabras con su cantidad de apariciones en el
                                        texto
                                    </Typography>
                                    <Tooltip
                                        enterTouchDelay={0}
                                        leaveTouchDelay={15000}
                                        disableTouchListener={false}
                                        title={
                                            <p>
                                                El listado se presenta ordenado por cantidad de
                                                palabras, de mayor cantidad a menor cantidad. El
                                                usuario puede modificar este orden en la lista pero
                                                no se verá reflejado en la nube de palabras.
                                            </p>
                                        }
                                    >
                                        <IconButton size="small">
                                            <HelpIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <GenericTable
                                        rows={Object.entries(
                                            dataGraph[actualGraph]?.words_table || {}
                                        ).map(([key, value], idx) => ({
                                            id: idx,
                                            term: key,
                                            cant: value,
                                        }))}
                                        columns={[
                                            {
                                                field: "term",
                                                headerName: "Término",
                                                width: 300,
                                            },
                                            {
                                                field: "cant",
                                                headerName: "Cantidad",
                                                width: 300,
                                            },
                                        ]}
                                    />
                                </AccordionDetails>
                            </Accordion>
                            {!Boolean(idActivity) && (
                                <Grid
                                    container
                                    gap={1}
                                    textAlign="center"
                                    sx={{
                                        pt: { xs: 2, lg: 4 },
                                        px: { xs: 0, lg: 10 },
                                        flexDirection: { xs: "column", lg: "row" },
                                    }}
                                    justifyContent="space-between"
                                >
                                    <Button
                                        disabled={Object.keys(dataGraph[actualGraph]).length === 0}
                                        variant="contained"
                                        onClick={() => onClickAddPartialDelivery()}
                                        sx={{
                                            backgroundColor: graphSelectedMap[actualGraph].selected
                                                ? "#db0909"
                                                : "#12416F",
                                            "&:hover": {
                                                backgroundColor: graphSelectedMap[actualGraph]
                                                    .selected
                                                    ? "#db0909"
                                                    : "#12416F",
                                            },
                                        }}
                                    >
                                        {graphSelectedMap[actualGraph].selected
                                            ? "Remover de entrega"
                                            : "Agregar a entrega"}
                                    </Button>
                                    {graphSelectedMap[actualGraph].selected &&
                                        graphSelectedMap[actualGraph]?.comment && (
                                            <Button
                                                disabled={
                                                    Object.keys(dataGraph[actualGraph]).length === 0
                                                }
                                                variant="contained"
                                                onClick={() => {
                                                    setCommentEditActualGraph(
                                                        graphSelectedMap[actualGraph]?.comment
                                                    );
                                                    setOpenDialogActualComment(
                                                        !openDialogActualComment
                                                    );
                                                }}
                                            >
                                                Editar observaciones
                                            </Button>
                                        )}
                                    <Button
                                        disabled={!hasSelectedGraphs}
                                        variant="contained"
                                        onClick={() => {
                                            exportMultipleChartsToPdf(
                                                Object.entries(graphSelectedMap)
                                                    .filter(([key, value]) => value.selected)
                                                    .map(([key, value]) => ({
                                                        ...value.export,
                                                        columns: [],
                                                        filterExclude: [],
                                                        filterInclude: [],
                                                        graph: key,
                                                        comment: value.comment,
                                                    })),
                                                [],
                                                studentActivity,
                                                activity,
                                                commentResolution || ""
                                            );
                                        }}
                                    >
                                        Previsualizar
                                    </Button>
                                    <Button
                                        disabled={!hasSelectedGraphs}
                                        variant="contained"
                                        onClick={() => setOpenResolutionDialog(true)}
                                    >
                                        Realizar Entrega
                                    </Button>
                                    {!hasSelectedGraphs && Object.keys(dataGraph[actualGraph]).length > 0 && (
                                        <Grid item xs={12}>
                                            <FormHelperText>
                                                Agregá el gráfico a la entrega antes de previsualizarla o enviarla.
                                            </FormHelperText>
                                        </Grid>
                                    )}
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                )}

                {actualGraph !== "word_cloud" && (
                    <Accordion defaultExpanded>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>Configuración del gráfico</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid textAlign={"center"} item xs={12} lg={12}>
                                <h3 style={{ margin: 0 }}>Seleccionar tipo de gráfico</h3>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                        name="controlled-radio-buttons-group"
                                        value={actualGraph}
                                        onChange={handleChangeGraph}
                                    >
                                        {graphListAvailable.length > 0 &&
                                            graphs
                                                .filter(
                                                    (graph) =>
                                                        graph.dataSource === "static" &&
                                                        graphListAvailable.includes(graph.value)
                                                )
                                                .sort((a, b) => a.name.localeCompare(b.name))
                                                .map((graph) => (
                                                    <FormControlLabel
                                                        key={graph.value}
                                                        value={graph.value}
                                                        control={<Radio />}
                                                        label={
                                                            <Tooltip
                                                                enterTouchDelay={0}
                                                                leaveTouchDelay={15000}
                                                                disableTouchListener={false}
                                                                title={
                                                                    <img
                                                                        src={`/img/charts/${graph.name}.png`}
                                                                        alt={graph.name}
                                                                        width="100%"
                                                                        // height="20"
                                                                    />
                                                                }
                                                            >
                                                                <p>{graph.name}</p>
                                                            </Tooltip>
                                                        }
                                                    />
                                                ))}
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid minHeight={400} container mt={2}>
                                <Grid item lg={9} xs={12}>
                                    {datasetColumns?.length > 0 && (
                                        <div className={classes.dndContainer}>
                                            <div style={{ display: "flex" }}>
                                                <DndComponent
                                                    callback={updateColumns}
                                                    data={{
                                                        items: {
                                                            datasetColumns,
                                                            ...graphSelectedMap[actualGraph]
                                                                .columns,
                                                        },
                                                        limitDrag:
                                                            graphSelectedMap[actualGraph].limitDrag,
                                                    }}
                                                    refresh={refreshResetDnd}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </Grid>
                                <Grid
                                    item
                                    lg={3}
                                    xs={12}
                                    textAlign="center"
                                    sx={{
                                        pt: { xs: 2, lg: 5 },
                                        px: { xs: 0, lg: 2 },
                                    }}
                                >
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Button
                                                disabled={
                                                    Object.keys(dataGraph[actualGraph] || {})
                                                        .length > 0 || !checkSelectedColumns()
                                                }
                                                variant="contained"
                                                fullWidth
                                                onClick={() =>
                                                    setOpenDialogFilter(!openDialogFilter)
                                                }
                                            >
                                                Filtros
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Button
                                                disabled={
                                                    Object.keys(dataGraph[actualGraph] || {})
                                                        .length > 0 || !checkSelectedColumns()
                                                }
                                                variant="contained"
                                                fullWidth
                                                onClick={() => handleClickGraphic()}
                                            >
                                                Graficar
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Button
                                                variant="contained"
                                                fullWidth
                                                disabled={
                                                    Object.keys(dataGraph[actualGraph] || {})
                                                        .length === 0
                                                }
                                                onClick={() => {
                                                    setOpenAnotherSearch(!openAnotherSearch);
                                                }}
                                            >
                                                Reiniciar gráfico
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    <GenericDialog
                                        title="Filtros"
                                        open={openDialogFilter}
                                        setOpen={setOpenDialogFilter}
                                        handleSave={() => saveFilter()}
                                        mandatoryText={false}
                                    >
                                        <DialogContent>
                                            <FilterDataset
                                                columns={datasetColumns}
                                                studentActivity={studentActivityId}
                                                onDeleteFilterCallback={(obj, criterion) => {
                                                    onDeleteFilterCallback(obj, criterion);
                                                }}
                                                addFilterCallback={(
                                                    newCriterion,
                                                    criterions,
                                                    criterionType
                                                ) => {
                                                    addFilterCallback(
                                                        newCriterion,
                                                        criterions,
                                                        criterionType
                                                    );
                                                }}
                                                includeChipLoadedList={
                                                    staticdataSource !== null
                                                        ? graphSelectedMap[actualGraph]
                                                              .filterInclude.length > 0
                                                            ? graphSelectedMap[actualGraph]
                                                                  .filterInclude
                                                            : null
                                                        : null
                                                }
                                                excludeChipLoadedList={
                                                    staticdataSource !== null
                                                        ? graphSelectedMap[actualGraph]
                                                              .filterExclude.length > 0
                                                            ? graphSelectedMap[actualGraph]
                                                                  .filterExclude
                                                            : null
                                                        : null
                                                }
                                            />
                                        </DialogContent>
                                    </GenericDialog>
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                )}
                {actualGraph !== "word_cloud" && (
                    <Accordion defaultExpanded>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>Vista previa de gráfico</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid item xs={12} md={12} textAlign="center">
                                <GrapherResolutionData
                                    graphSelectedMap={graphSelectedMap}
                                    graphs={graphs}
                                    dataSource={dataSource}
                                    valueTab={valueTabParent}
                                    actualGraph={actualGraph}
                                    mapGraphSelectedMapTab={mapGraphSelectedMapTab}
                                    onDeleteFilterApplied={onDeleteFilterApplied}
                                />
                            </Grid>
                            <Grid container>
                                <Grid textAlign="center" item xs={12} lg={12}>
                                    {actualGraph === "pie" && (
                                        <PieChart
                                            data={dataGraph[actualGraph]}
                                            xAxis={
                                                graphSelectedMap[actualGraph].columns?.valuePie[0]
                                            }
                                        />
                                    )}

                                    {actualGraph === "column" && (
                                        <ColumnsChart
                                            data={dataGraph[actualGraph]}
                                            xAxis={graphSelectedMap[actualGraph].columns.value[0]}
                                            yAxis={
                                                graphSelectedMap[actualGraph].columns.group_by[0]
                                            }
                                        />
                                    )}

                                    {actualGraph === "line" && (
                                        <LineChart
                                            data={dataGraph[actualGraph]}
                                            xAxis={graphSelectedMap[actualGraph].columns.value[0]}
                                            yAxis={
                                                graphSelectedMap[actualGraph].columns.group_by[0]
                                            }
                                        />
                                    )}

                                    {actualGraph === "bubble" && (
                                        <BubbleChart
                                            data={dataGraph[actualGraph]}
                                            xAxis={graphSelectedMap[actualGraph].columns.value[0]}
                                            yAxis={
                                                graphSelectedMap[actualGraph].columns.group_by[0]
                                            }
                                        />
                                    )}

                                    {actualGraph === "map" && (
                                        <MapChartGrapher data={dataGraph[actualGraph]} />
                                    )}

                                    {actualGraph === "static_network" && (
                                        <>
                                            <Tabs
                                                sx={{ py: "10px" }}
                                                value={valueGraphTab}
                                                onChange={handleChangeGraphTab}
                                                aria-label="Tabs for different social network metrics"
                                            >
                                                <Tab
                                                    label={
                                                        <p
                                                            style={{
                                                                alignItems: "center",
                                                                display: "flex",
                                                            }}
                                                        >
                                                            Grafo (Grado)
                                                            <Tooltip
                                                                enterTouchDelay={0}
                                                                leaveTouchDelay={15000}
                                                                disableTouchListener={false}
                                                                title={
                                                                    <p>
                                                                        El grado de un nodo, en un
                                                                        grafo no dirigido, se
                                                                        calcula sumando la cantidad
                                                                        de aristas que llegan a él.
                                                                        Por ejemplo: sean “a”, “b” y
                                                                        “c” nodos, mientras que “--”
                                                                        representa una arista entre
                                                                        dos nodos. Si se tienen las
                                                                        siguientes conexiones: a --
                                                                        b, a -- c y b -- a, el grado
                                                                        “()” de cada nodo es: a(3),
                                                                        b(2), c(1)
                                                                    </p>
                                                                }
                                                            >
                                                                <IconButton size="small">
                                                                    <HelpIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </p>
                                                    }
                                                />
                                                <Tab
                                                    label={
                                                        <p
                                                            style={{
                                                                alignItems: "center",
                                                                display: "flex",
                                                            }}
                                                        >
                                                            Grafo (Intermediación)
                                                            <Tooltip
                                                                enterTouchDelay={0}
                                                                leaveTouchDelay={15000}
                                                                disableTouchListener={false}
                                                                title={
                                                                    <p>
                                                                        Mide la frecuencia con la
                                                                        que un nodo aparece en los
                                                                        caminos más cortos entre
                                                                        todos los pares de nodos de
                                                                        la red. Conocido como grado
                                                                        de intermediación
                                                                        (Betweenness centrality)
                                                                        pada determinar el tamaño de
                                                                        un nodo. Ejemplo: a{"->"}
                                                                        b, a{"->"}c, b-a la
                                                                        centralidad más alta es para
                                                                        el nodo "a" porque es el
                                                                        único nodo que actúa como
                                                                        puente en el camino más
                                                                        corto entre b y c, la
                                                                        centralidad para a(1), está
                                                                        a un nodo de distancia de
                                                                        los restantes, mientras que
                                                                        para b(0) y c(0), ya que no
                                                                        son camino de ningún otro
                                                                        nodo
                                                                    </p>
                                                                }
                                                            >
                                                                <IconButton size="small">
                                                                    <HelpIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </p>
                                                    }
                                                />
                                            </Tabs>
                                            {valueGraphTab === 0 && (
                                                <StaticNetworkChart data={dataGraph[actualGraph]} />
                                            )}
                                            {valueGraphTab === 1 && (
                                                <StaticNetworkBetweennessChart
                                                    data={dataGraph[actualGraph]}
                                                />
                                            )}
                                        </>
                                    )}

                                    {!Boolean(idActivity) && (
                                        <Grid
                                            container
                                            gap={1}
                                            textAlign="center"
                                            sx={{
                                                pt: { xs: 2, lg: 4 },
                                                px: { xs: 0, lg: 10 },
                                                flexDirection: { xs: "column", lg: "row" },
                                            }}
                                            justifyContent="space-between"
                                        >
                                            <Button
                                                disabled={
                                                    Object.keys(dataGraph[actualGraph] || {})
                                                        .length === 0
                                                }
                                                variant="contained"
                                                onClick={() => onClickAddPartialDelivery()}
                                                sx={{
                                                    backgroundColor: graphSelectedMap[actualGraph]
                                                        ?.selected
                                                        ? "#db0909"
                                                        : "#12416F",
                                                    "&:hover": {
                                                        backgroundColor: graphSelectedMap[
                                                            actualGraph
                                                        ]?.selected
                                                            ? "#db0909"
                                                            : "#12416F",
                                                    },
                                                }}
                                            >
                                                {graphSelectedMap[actualGraph]?.selected
                                                    ? "Remover de entrega"
                                                    : "Agregar a entrega"}
                                            </Button>
                                            {graphSelectedMap[actualGraph].selected &&
                                                graphSelectedMap[actualGraph]?.comment && (
                                                    <Button
                                                        disabled={
                                                            Object.keys(dataGraph[actualGraph])
                                                                .length === 0
                                                        }
                                                        variant="contained"
                                                        onClick={() =>
                                                            setOpenDialogActualComment(
                                                                !openDialogActualComment
                                                            )
                                                        }
                                                    >
                                                        Editar observaciones
                                                    </Button>
                                                )}
                                            <Button
                                                disabled={
                                                    Object.keys(dataGraph[actualGraph] || {})
                                                        .length === 0 ||
                                                    !graphSelectedMap[actualGraph]?.selected
                                                }
                                                variant="contained"
                                                onClick={() => {
                                                    exportMultipleChartsToPdf(
                                                        Object.entries(graphSelectedMap)
                                                            .filter(([_, value]) => value.selected)
                                                            .map(([key, value]) => ({
                                                                ...value.export,
                                                                columns: value.columns,
                                                                filterExclude: value.filterExclude,
                                                                filterInclude: value.filterInclude,
                                                                graph: key,
                                                                comment: value.comment,
                                                            })),
                                                        datasetColumns,
                                                        studentActivity,
                                                        commentResolution || ""
                                                    );
                                                }}
                                            >
                                                Previsualizar
                                            </Button>

                                            <Button
                                                disabled={
                                                    Object.keys(dataGraph[actualGraph] || {})
                                                        .length === 0 ||
                                                    !graphSelectedMap[actualGraph]?.selected
                                                }
                                                variant="contained"
                                                onClick={() => setOpenResolutionDialog(true)}
                                            >
                                                Realizar Entrega
                                            </Button>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                )}
            </TabPanelComponent>
            <TabPanelComponent value={valueTab} index={1}>
                <SocialGraphs
                    dataGraphCached={dataGraph}
                    setDataGraphCached={setDataGraph}
                    graphSelectedMap={graphSelectedMap}
                    setGraphSelectedMap={setGraphSelectedMap}
                    sendResolution={sendResolution}
                    studentActivity={studentActivity}
                    commentResolution={commentResolution}
                    setOpenResolutionDialog={setOpenResolutionDialog}
                    activity={activity}
                />
            </TabPanelComponent>
            {!Boolean(idActivity) && (
                <QuestionAnswerForum
                    studentActivity={studentActivity}
                    updateData={getStudentActivity}
                />
            )}
            <br />
            <br />
            <br />
            <GenericDialog
                title="Editar observaciones"
                open={openDialogActualComment}
                setOpen={setOpenDialogActualComment}
                handleSave={() => {
                    if (commentEditActualGraph.length === 0) {
                        setAlertText("Debe completar la observación!");
                        setSeverity("error");
                        setShowAlert(true);
                        setTimeout(() => {
                            setShowAlert(false);
                            setAlertText("");
                            setSeverity("");
                        }, 2000);
                        return;
                    }
                    setConfirmEditComment(true);
                }}
            >
                <DialogContent>
                    <FormControl>
                        <h3 style={{ margin: 0 }}>Actividad</h3>
                        <Typography variant="p" sx={{ mb: 2 }}>
                            {activity?.title}
                        </Typography>
                        <h3 style={{ margin: 0 }}>Enunciado</h3>
                        <Typography variant="p" sx={{ mb: 2 }}>
                            {activity?.statement}
                        </Typography>
                        <h3 style={{ margin: 0 }}>Descripción</h3>
                        <Typography variant="p" sx={{ mb: 2 }}>
                            {activity?.description}
                        </Typography>
                        <h3>
                            A partir del gráfico analizado, ¿Qué observaciones puede compartir con
                            el profesor?
                        </h3>
                        <TextareaAutosize
                            placeholder="Observaciones *"
                            required
                            maxLength={1000}
                            defaultValue={graphSelectedMap[actualGraph]?.comment}
                            value={commentEditActualGraph}
                            onChange={(evt) => {
                                setCommentEditActualGraph(evt.target.value);
                            }}
                            minRows={5}
                            style={{ width: "100%", padding: "15px" }}
                        />
                        <FormHelperText sx={{ textAlign: "right" }}>
                            {`${commentEditActualGraph.length} / 1000`}
                        </FormHelperText>
                    </FormControl>
                </DialogContent>
            </GenericDialog>
            <GenericDialog
                title="Agregar a entrega"
                open={openPartialDeliveryDialog}
                setOpen={setOpenPartialDeliveryDialog}
                handleSave={() => {
                    if ((graphSelectedMap[actualGraph]?.comment?.length || 0) === 0) {
                        setAlertText("Debe completar la observación!");
                        setSeverity("error");
                        setShowAlert(true);
                        setTimeout(() => {
                            setShowAlert(false);
                            setAlertText("");
                            setSeverity("");
                        }, 2000);
                        return;
                    }
                    setOpenAddToDelivery(!openAddToDelivery);
                }}
                onClose={() => {
                    setGraphSelectedMap({
                        ...graphSelectedMap,
                        [actualGraph]: {
                            ...graphSelectedMap[actualGraph],
                            comment: "",
                        },
                    });
                }}
            >
                <DialogContent>
                    <FormControl>
                        <h3 style={{ margin: 0 }}>Actividad</h3>
                        <Typography variant="p" sx={{ mb: 2 }}>
                            {activity?.title}
                        </Typography>
                        <h3 style={{ margin: 0 }}>Enunciado</h3>
                        <Typography variant="p" sx={{ mb: 2 }}>
                            {activity?.statement}
                        </Typography>
                        <h3 style={{ margin: 0 }}>Descripción</h3>
                        <Typography variant="p" sx={{ mb: 2 }}>
                            {activity?.description}
                        </Typography>
                        <h3>
                            A partir del gráfico analizado, ¿Qué observaciones puede compartir con
                            el profesor?
                        </h3>
                        <TextareaAutosize
                            placeholder="Observaciones *"
                            required
                            maxLength={1000}
                            value={graphSelectedMap[actualGraph]?.comment}
                            onChange={(evt) => {
                                setGraphSelectedMap({
                                    ...graphSelectedMap,
                                    [actualGraph]: {
                                        ...graphSelectedMap[actualGraph],
                                        comment: evt.target.value,
                                    },
                                });
                            }}
                            minRows={5}
                            style={{ width: "100%", padding: "15px" }}
                        />
                        <FormHelperText sx={{ textAlign: "right" }}>
                            {`${graphSelectedMap[actualGraph]?.comment?.length || 0} / 1000`}
                        </FormHelperText>
                    </FormControl>
                </DialogContent>
            </GenericDialog>
            <GenericDialog
                onClose={() => setCommentResolution("")}
                title="Realizar entrega"
                open={openResolutionDialog}
                setOpen={setOpenResolutionDialog}
                saveButtonText="Enviar"
                cancelButtonText="Cancelar"
                mandatoryText={false}
                handleSave={() => {
                    setOpenConfirmDialog(true);
                }}
            >
                <DialogContent>
                    <FormControl>
                        <h3 style={{ margin: 0 }}>Actividad</h3>
                        <Typography variant="p" sx={{ mb: 2 }}>
                            {activity?.title}
                        </Typography>
                        <h3 style={{ margin: 0 }}>Enunciado</h3>
                        <Typography variant="p" sx={{ mb: 2 }}>
                            {activity?.statement}
                        </Typography>
                        <h3 style={{ margin: 0 }}>Descripción</h3>
                        <Typography variant="p" sx={{ mb: 2 }}>
                            {activity?.description}
                        </Typography>
                        <h3>
                            Antes de realizar la entrega, podes dejar observaciones generales con
                            relación a esta nueva entrega de la actividad para el profesor. <br />
                            (No obligatorio)
                        </h3>
                        <TextareaAutosize
                            maxLength={1000}
                            value={commentResolution}
                            onChange={(evt) => setCommentResolution(evt.target.value)}
                            minRows={5}
                            style={{ width: "100%", padding: "15px" }}
                        />
                        <FormHelperText sx={{ textAlign: "right" }}>
                            {`${commentResolution.length} / 1000`}
                        </FormHelperText>
                    </FormControl>
                </DialogContent>
            </GenericDialog>
            <GenericDialog
                title="¿Está seguro que quiere realizar la entrega?"
                open={openConfirmDialog}
                setOpen={setOpenConfirmDialog}
                handleSave={() => sendResolution()}
                mandatoryText={false}
            >
                <DialogContent>
                    Una vez entregada no podrá realizar cambios en la misma
                </DialogContent>
            </GenericDialog>
            <GenericDialog
                title="¿Está seguro de que desea agregar el gráfico y las observaciones como parte de la entrega?"
                open={openAddToDelivery}
                setOpen={setOpenAddToDelivery}
                handleSave={() => {
                    setOpenLoader(true);
                    setTimeout(() => {
                        addPartialDelivery();
                        setOpenAddToDelivery(!openAddToDelivery);
                    }, 2000);
                }}
                cancelButtonText="No"
                saveButtonText="Si"
                mandatoryText={false}
            ></GenericDialog>
            <GenericDialog
                title="Si reinicia el gráfico perderá el progreso actual ¿Desea continuar?"
                open={openAnotherSearch}
                setOpen={setOpenAnotherSearch}
                handleSave={() => {
                    setDataGraph({
                        ...dataGraph,
                        [actualGraph]: {},
                    });
                    setGraphSelectedMap({
                        ...graphSelectedMap,
                        [actualGraph]: DEFAULT_DATA_GRAPHER[actualGraph],
                    });
                    setRefreshResetDnd(!refreshResetDnd);
                    setOpenAnotherSearch(!openAnotherSearch);
                }}
                cancelButtonText="No"
                saveButtonText="Si"
                mandatoryText={false}
            ></GenericDialog>
            <GenericDialog
                title="¿Desea remover de la entrega al gráfico y a sus observaciones?"
                open={openRemoveGraph}
                setOpen={setOpenRemoveGraph}
                handleSave={() => {
                    setGraphSelectedMap({
                        ...graphSelectedMap,
                        [actualGraph]: {
                            ...graphSelectedMap[actualGraph],
                            selected: !graphSelectedMap[actualGraph].selected,
                            comment: "",
                            export: {},
                        },
                    });
                    setOpenRemoveGraph(false);
                }}
                cancelButtonText="No"
                saveButtonText="Si"
                mandatoryText={false}
            ></GenericDialog>
            <GenericDialog
                title="Desea editar las observaciones?"
                open={confirmEditComment}
                setOpen={setConfirmEditComment}
                handleSave={() => {
                    setGraphSelectedMap({
                        ...graphSelectedMap,
                        [actualGraph]: {
                            ...graphSelectedMap[actualGraph],
                            comment: commentEditActualGraph,
                        },
                    });
                    setConfirmEditComment(false);
                    setOpenDialogActualComment(false);
                }}
                cancelButtonText="No"
                saveButtonText="Si"
                mandatoryText={false}
            ></GenericDialog>
            {showAlert && (
                <Grid md={3} sx={{ position: "fixed", top: "40%", left: "45%", zIndex: 9999 }}>
                    <GenericAlert severity={severity} text={alertText}></GenericAlert>
                </Grid>
            )}
            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: 999999999,
                }}
                open={openLoader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};

export default TabNewResolution;
